export const consumableFragment = gql`
    fragment consumableFragment on ConsumableType {
        id
        uuid
        name
        pricePerUnit
        supplier {
            id
            name
        }
        itemCode
        nonClinical
        containedIn {
            id
        }
        createdAt
    }
`;

export const consumableSupplierFragment = gql`
    fragment consumableSupplierFragment on ConsumableSupplierType {
        id
        uuid
        name
        createdAt
    }
`;
